import { render, staticRenderFns } from "./video-wall.vue?vue&type=template&id=58408cd1&scoped=true&"
import script from "./video-wall.vue?vue&type=script&lang=js&"
export * from "./video-wall.vue?vue&type=script&lang=js&"
import style0 from "./video-wall.vue?vue&type=style&index=0&id=58408cd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58408cd1",
  null
  
)

export default component.exports